import { FormattedMessage } from "react-intl";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import PaymentModesTooltipContainer from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltipContainer";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import PropTypes from "prop-types";
import { paymentTypeShape } from "app/utils/propTypes";
import "./DepositDescriptionTerms.scss";
import PaymentCardGroupIcon from "app/pages/.shared/static/icons/PaymentCardGroupIcon";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const DepositDescriptionTerms = ({
	availablePaymentTerms = [],
	availablePaymentMethods = [],
	onlinePercentage,
}) => {
	return availablePaymentTerms.length > 1 ? (
		<div className="deposit-description-terms" data-testid="deposit-description-terms">
			<PaymentCardGroupIcon width={15} height={13} />
			<Typography
				variant={TYPOGRAPHY_VARIANTS.SMALL}
				isBold
				className="deposit-description-terms__description"
			>
				<div className="deposit-description-terms__description-label">
					<FormattedMessage
						id="payment.terms.description.label"
						values={{ percentage: onlinePercentage }}
					/>
				</div>
				<div className="deposit-description-terms__description-deposit-label">
					{" "}
					<FormattedMessage id="payment.methods.deposit.label" />
				</div>
			</Typography>

			<FloatingButton
				position="bottom"
				floatingContent={
					<PaymentModesTooltipContainer paymentModes={availablePaymentMethods} />
				}
				referenceComponent={<IconInfo width={12} height={12} />}
			/>
		</div>
	) : null;
};

DepositDescriptionTerms.propTypes = {
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	availablePaymentMethods: PropTypes.array,
	onlinePercentage: PropTypes.number,
};
export default DepositDescriptionTerms;
